import { timelineSpot } from "@/mocks/heiliao";

const tagStyle: Record<string, string> = {
  原帖: "bg-background-200 text-foreground-700",
  截图: "bg-primary-100 text-primary-700",
  录音: "bg-accent-100 text-accent-900",
  进展: "bg-secondary-200 text-secondary-900",
  公告: "bg-primary-100 text-primary-700",
  存疑: "bg-accent-100 text-accent-900",
};

export default function TimelineSpotlight() {
  return (
    <section id="timeline" className="scroll-mt-20 bg-background-100/70 py-10 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-accent-700">
            <i className="ri-timeline-view text-sm"></i>{timelineSpot.kicker}
          </div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            {timelineSpot.title}
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">{timelineSpot.desc}</p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-10">
          <div className="order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-xl border border-background-200">
              <img
                src={timelineSpot.cover}
                alt="代言危机事件时间线梳理档案示意"
                title="代言危机事件时间线梳理档案示意"
                className="h-full w-full object-cover"
              />
              <div className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-3 py-1 text-xs text-background-50 backdrop-blur">
                <i className="ri-folder-2-fill mr-1 text-accent-400"></i>7 个关键节点
              </div>
            </div>
            <div className="mt-4 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-xs leading-5 text-foreground-500">
              <i className="ri-question-line mr-1 text-accent-600"></i>
              想自己核？每张图都标了来源。我们只负责把节点排出来，最后结论留给你判断。
            </div>
          </div>

          <ol className="order-1 lg:order-2">
            {timelineSpot.events.map((e, i) => (
              <li key={e.time} className="relative flex gap-4 pb-6 last:pb-0">
                {i < timelineSpot.events.length - 1 && (
                  <span className="absolute left-[5px] top-5 h-full w-px bg-background-300"></span>
                )}
                <span
                  className={
                    "relative z-10 mt-1.5 h-[11px] w-[11px] shrink-0 rounded-full border-2 border-background-50 " +
                    (i === 0
                      ? "bg-primary-500"
                      : i === timelineSpot.events.length - 1
                        ? "bg-accent-500"
                        : "bg-secondary-400")
                  }
                ></span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-xs font-bold tracking-wide text-foreground-700">
                      {e.time}
                    </span>
                    <span className={"whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold " + (tagStyle[e.tag] ?? tagStyle.原帖)}>
                      {e.tag}
                    </span>
                  </div>
                  <h3 className="mt-1 font-bold text-foreground-950">{e.title}</h3>
                  <p className="mt-1 text-sm leading-6 text-foreground-600">{e.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}